import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ScrollToTop } from './components/ScrollToTop';
import { Home } from './pages/Home';
import { Procedures } from './pages/Procedures';
import { ProcedureDetail } from './pages/ProcedureDetail';
import { Destinations } from './pages/Destinations';
import { DestinationDetail } from './pages/DestinationDetail';
import { HowItWorks } from './pages/HowItWorks';
import { PatientGuide } from './pages/PatientGuide';
import { About } from './pages/About';
import { Faq } from './pages/Faq';
import { Contact } from './pages/Contact';
import { PartnerFacility } from './pages/PartnerFacility';
import { PartnerFacilitator } from './pages/PartnerFacilitator';
import { Hospitals } from './pages/Hospitals';
import { HospitalDetail } from './pages/HospitalDetail';
import { Facilitators } from './pages/Facilitators';
import { FacilitatorDetail } from './pages/FacilitatorDetail';
import { Sitemap } from './pages/Sitemap';
import { Terms } from './pages/Terms';
import { Privacy } from './pages/Privacy';
import { MedicalDisclaimer } from './pages/MedicalDisclaimer';
import { AccessibilityStatement } from './pages/AccessibilityStatement';
import { CookiePolicy } from './pages/CookiePolicy';
import { NotFound } from './pages/NotFound';
export function App() {
  return <HelmetProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <ScrollToTop behavior="smooth" data-id="element-2" />
        <Routes data-id="element-3">
          <Route path="/" element={<Home data-id="element-5" />} data-id="element-4" />
          <Route path="/procedures" element={<Procedures data-id="element-7" />} data-id="element-6" />
          <Route path="/procedures/:slug" element={<ProcedureDetail data-id="element-9" />} data-id="element-8" />
          <Route path="/destinations" element={<Destinations data-id="element-11" />} data-id="element-10" />
          <Route path="/destinations/:slug" element={<DestinationDetail data-id="element-13" />} data-id="element-12" />
          <Route path="/hospitals" element={<Hospitals data-id="element-15" />} data-id="element-14" />
          <Route path="/hospitals/:slug" element={<HospitalDetail data-id="element-17" />} data-id="element-16" />
          <Route path="/facilitators" element={<Facilitators data-id="element-19" />} data-id="element-18" />
          <Route path="/facilitators/:slug" element={<FacilitatorDetail data-id="element-21" />} data-id="element-20" />
          <Route path="/how-it-works" element={<HowItWorks data-id="element-23" />} data-id="element-22" />
          <Route path="/patient-guide" element={<PatientGuide data-id="element-25" />} data-id="element-24" />
          <Route path="/about" element={<About data-id="element-27" />} data-id="element-26" />
          <Route path="/faq" element={<Faq data-id="element-29" />} data-id="element-28" />
          <Route path="/contact" element={<Contact data-id="element-31" />} data-id="element-30" />
          <Route path="/partner-facility" element={<PartnerFacility data-id="element-33" />} data-id="element-32" />
          <Route path="/partner-facilitator" element={<PartnerFacilitator data-id="element-35" />} data-id="element-34" />
          <Route path="/sitemap" element={<Sitemap data-id="element-37" />} data-id="element-36" />
          <Route path="/terms" element={<Terms data-id="element-39" />} data-id="element-38" />
          <Route path="/privacy" element={<Privacy data-id="element-41" />} data-id="element-40" />
          <Route path="/medical-disclaimer" element={<MedicalDisclaimer data-id="element-43" />} data-id="element-42" />
          <Route path="/accessibility-statement" element={<AccessibilityStatement data-id="element-45" />} data-id="element-44" />
          <Route path="/cookie-policy" element={<CookiePolicy data-id="element-47" />} data-id="element-46" />
          <Route path="*" element={<NotFound data-id="element-49" />} data-id="element-48" />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>;
}